import React from 'react';
import PatentForm from './components/PatentForm';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import FileViewer from './components/FileViewer.js';
import './App.css';
import IndivisualSection from './components/IndivisualSection.js';
import Preview from './preview/preview.js';
import Patentpreview from './preview/patentpreview.js';
import Login from './Login.js';
import PrivateRoute from './components/PrivateRoute';

const App = () => (
  <Router>
    <div className="app-container">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/patentform"
          element={
            <PrivateRoute>
              <PatentForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/file-viewer"
          element={
            <PrivateRoute>
              <FileViewer />
            </PrivateRoute>
          }
        />
        <Route
          path="/section"
          element={
            <PrivateRoute>
              <IndivisualSection />
            </PrivateRoute>
          }
        />
        <Route
          path="/preview"
          element={
            <PrivateRoute>
              <Preview />
            </PrivateRoute>
          }
        />
        <Route
          path="/fullpreview"
          element={
            <PrivateRoute>
              <Patentpreview />
            </PrivateRoute>
          }
        />
      </Routes>
    </div>
  </Router>
);

export default App;
